import { Theme } from "@emotion/react";
import { SxProps, Typography } from "@mui/material";
import { ReactNode } from "react";

interface FieldLabelProps {
  children: ReactNode;
  required?: boolean;
  sx?: SxProps<Theme>;
}

const defaultLabelSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: 12,
  color: "#666",
  marginBottom: 0.75,
};

const FieldLabel = ({ children, required, sx }: FieldLabelProps) => {
  return (
    <Typography sx={{ ...defaultLabelSx, ...sx }}>
      {children}
      {required ? " *" : ""}
    </Typography>
  );
};

export default FieldLabel;